import DE_PRIVACY_POLICY_PAGE_CONSTANTS from './de'
import EN_PRIVACY_POLICY_PAGE_CONSTANTS from './en'
import FR_PRIVACY_POLICY_PAGE_CONSTANTS from './fr'
import HU_PRIVACY_POLICY_PAGE_CONSTANTS from './hu'
import { T_PRIVACY_POLICY_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const PRIVACY_POLICY_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_PRIVACY_POLICY_PAGE_CONSTANTS> =
  {
    hu: HU_PRIVACY_POLICY_PAGE_CONSTANTS,
    en: EN_PRIVACY_POLICY_PAGE_CONSTANTS,
    fr: FR_PRIVACY_POLICY_PAGE_CONSTANTS,
    de: DE_PRIVACY_POLICY_PAGE_CONSTANTS
  }

export default PRIVACY_POLICY_PAGE_CONSTANTS

export const PRIVACY_POLICY_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_PRIVACY_POLICY_PAGE_CONSTANTS>()
